function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M144.37 22.05H145.57V30.7H144.57V24.46C144.568 24.0607 144.605 23.6621 144.68 23.27V23.27C144.542 23.6813 144.368 24.0795 144.16 24.46L141.69 29.14H140.69L138.22 24.46C138.012 24.0795 137.838 23.6813 137.7 23.27C137.78 23.6616 137.82 24.0603 137.82 24.46V30.7H136.82V22.05H138L141.19 28.05L144.37 22.05Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M153.89 27.26V22.05H154.89V27.26C154.915 27.728 154.845 28.1963 154.683 28.6362C154.521 29.0761 154.272 29.4784 153.949 29.8186C153.627 30.1589 153.239 30.4298 152.808 30.615C152.377 30.8002 151.914 30.8957 151.445 30.8957C150.976 30.8957 150.513 30.8002 150.082 30.615C149.651 30.4298 149.263 30.1589 148.941 29.8186C148.618 29.4784 148.369 29.0761 148.207 28.6362C148.045 28.1963 147.975 27.728 148 27.26V22.05H149V27.26C148.955 27.601 148.986 27.9476 149.091 28.2752C149.196 28.6028 149.371 28.9033 149.605 29.1554C149.839 29.4074 150.126 29.6048 150.444 29.7335C150.763 29.8622 151.107 29.9191 151.45 29.9C151.792 29.914 152.132 29.8537 152.448 29.7231C152.764 29.5926 153.048 29.3949 153.28 29.1438C153.512 28.8927 153.687 28.5942 153.792 28.269C153.897 27.9437 153.931 27.5994 153.89 27.26V27.26Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M157.59 22.05H159.59L157.89 27.31L159.73 29.86L162.73 27.68V22.05H163.73V30.7H162.73V28.84L160.2 30.7H159.2L156.86 27.5L158.34 23H157.59V22.05Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M166.9 24.11C166.92 24.4181 167.038 24.7118 167.235 24.949C167.433 25.1861 167.701 25.3545 168 25.43L169.36 25.88C170.95 26.39 171.45 27.29 171.45 28.35C171.45 29.75 170.54 30.82 168.63 30.82C167.642 30.8226 166.661 30.6708 165.72 30.37L166 29.49C166.849 29.7673 167.737 29.9091 168.63 29.91C170.11 29.91 170.46 29.2 170.46 28.36C170.42 27.9864 170.265 27.6345 170.016 27.3532C169.766 27.0719 169.436 26.875 169.07 26.79L167.58 26.32C167.089 26.2167 166.65 25.9433 166.341 25.5482C166.032 25.153 165.872 24.6614 165.89 24.16C165.89 22.79 166.98 21.92 168.63 21.92C169.478 21.956 170.317 22.1143 171.12 22.39L170.83 23.27C170.12 23.0274 169.379 22.8827 168.63 22.84C167.58 22.84 166.9 23.28 166.9 24.11Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M173.34 30.7V22.05H178.64L178.44 22.96H174.33V25.82H177.74V26.73H174.33V29.78H178.68V30.7H173.34Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M186.7 27.26V22.05H187.7V27.26C187.7 28.1723 187.338 29.0473 186.692 29.6925C186.047 30.3376 185.172 30.7 184.26 30.7C183.348 30.7 182.473 30.3376 181.828 29.6925C181.182 29.0473 180.82 28.1723 180.82 27.26V22.05H181.82V27.26C181.774 27.6004 181.803 27.9469 181.907 28.2745C182.01 28.6021 182.185 28.9029 182.418 29.1552C182.651 29.4075 182.937 29.6051 183.255 29.7338C183.574 29.8626 183.917 29.9194 184.26 29.9C184.602 29.914 184.942 29.8537 185.258 29.7231C185.574 29.5926 185.858 29.3949 186.09 29.1438C186.322 28.8927 186.497 28.5942 186.602 28.269C186.707 27.9437 186.741 27.5994 186.7 27.26V27.26Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M197.34 22.05H198.54V30.7H197.54V24.46C197.538 24.0607 197.575 23.6621 197.65 23.27V23.27C197.512 23.6813 197.338 24.0795 197.13 24.46L194.66 29.14H193.66L191.19 24.46C190.982 24.0795 190.808 23.6813 190.67 23.27C190.745 23.6621 190.782 24.0607 190.78 24.46V30.7H189.78V22.05H190.97L194.16 28.05L197.34 22.05Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M141.64 43.2V40.26H137.76V43.2H136.76V34.55H137.76V39.34H138.81L141.54 34.55H142.66L139.84 39.34H142.63V43.2H141.64Z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M148.7 34.42C149.584 34.4021 150.453 34.6478 151.196 35.1258C151.94 35.6038 152.524 36.2924 152.875 37.1038C153.226 37.9152 153.327 38.8126 153.165 39.6817C153.004 40.5507 152.587 41.352 151.969 41.9834C151.35 42.6148 150.557 43.0476 149.692 43.2268C148.826 43.4059 147.927 43.3232 147.109 42.9892C146.29 42.6552 145.59 42.085 145.097 41.3514C144.604 40.6178 144.34 39.7539 144.34 38.87C144.329 37.7021 144.782 36.5776 145.6 35.7434C146.417 34.9091 147.532 34.4332 148.7 34.42V34.42ZM148.7 42.42C149.406 42.4559 150.107 42.2795 150.712 41.9135C151.317 41.5475 151.799 41.0086 152.095 40.3663C152.391 39.7241 152.488 39.0079 152.373 38.31C152.258 37.6122 151.937 36.9648 151.451 36.4512C150.965 35.9375 150.336 35.5813 149.646 35.4284C148.955 35.2754 148.235 35.3328 147.577 35.593C146.92 35.8533 146.355 36.3046 145.956 36.8886C145.558 37.4727 145.343 38.1628 145.34 38.87C145.325 39.3243 145.401 39.7769 145.562 40.2018C145.723 40.6267 145.967 41.0155 146.28 41.3456C146.592 41.6756 146.967 41.9406 147.382 42.125C147.798 42.3094 148.246 42.4097 148.7 42.42Z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M157 34.55V40.55C157.044 40.9024 157.013 41.2603 156.907 41.5993C156.801 41.9384 156.624 42.2508 156.386 42.5153C156.149 42.7799 155.858 42.9904 155.533 43.1327C155.207 43.275 154.855 43.3457 154.5 43.34C154.193 43.3363 153.887 43.2961 153.59 43.22L153.77 42.35C153.976 42.4051 154.187 42.4353 154.4 42.44C155.4 42.44 156.01 41.82 156.01 40.55V34.55H157Z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M165.4 39.76V34.55H166.4V39.76C166.425 40.228 166.355 40.6963 166.193 41.1362C166.031 41.5761 165.782 41.9784 165.459 42.3186C165.137 42.6589 164.749 42.9298 164.318 43.115C163.887 43.3002 163.424 43.3957 162.955 43.3957C162.486 43.3957 162.023 43.3002 161.592 43.115C161.161 42.9298 160.773 42.6589 160.451 42.3186C160.128 41.9784 159.879 41.5761 159.717 41.1362C159.555 40.6963 159.485 40.228 159.51 39.76V34.55H160.51V39.76C160.465 40.101 160.496 40.4476 160.601 40.7752C160.706 41.1028 160.881 41.4033 161.115 41.6554C161.349 41.9074 161.636 42.1048 161.954 42.2335C162.273 42.3622 162.617 42.4191 162.96 42.4C163.302 42.414 163.642 42.3537 163.958 42.2231C164.274 42.0926 164.558 41.8949 164.79 41.6438C165.022 41.3927 165.197 41.0942 165.302 40.769C165.407 40.4437 165.441 40.0994 165.4 39.76V39.76Z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M178.38 43.2L175.08 39.2H174.38V43.2H173.38V34.55H174.38V38.32H175.08L178.28 34.55H179.28V34.76L175.83 38.76L179.39 43V43.21L178.38 43.2Z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M185.07 34.55L187.93 43V43.21H186.93L186.26 41.21H182.13L181.48 43.21H180.53V43L183.38 34.56L185.07 34.55ZM182.49 40.28H186L184.42 35.46H184.08L182.49 40.28Z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M191 34.55H193.69L196.42 43V43.21H195.47L194.91 41.43H190.82L190.26 43.21H189.26V43L191.71 35.47H191V34.55ZM191.12 40.55H194.63L193.03 35.55H192.7L191.12 40.55Z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M198.3 36.61C198.321 36.9207 198.442 37.2164 198.643 37.4539C198.845 37.6914 199.117 37.8582 199.42 37.93L200.78 38.38C202.36 38.89 202.87 39.79 202.87 40.85C202.87 42.25 201.96 43.32 200.05 43.32C199.059 43.3234 198.074 43.1715 197.13 42.87L197.42 41.99C198.269 42.2683 199.157 42.4101 200.05 42.41C201.52 42.41 201.88 41.7 201.88 40.86C201.839 40.4851 201.682 40.1322 201.431 39.8507C201.18 39.5693 200.848 39.3732 200.48 39.29L199 38.82C198.509 38.7167 198.07 38.4433 197.761 38.0482C197.452 37.653 197.292 37.1614 197.31 36.66C197.31 35.29 198.4 34.42 200.05 34.42C200.898 34.4571 201.737 34.6154 202.54 34.89L202.25 35.77C201.539 35.5293 200.799 35.3846 200.05 35.34C199 35.34 198.3 35.78 198.3 36.61Z"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M208 34.55L210.8 43V43.21H209.8L209.13 41.21H205.01L204.35 43.21H203.35V43L206.2 34.56L208 34.55ZM205.42 40.28H208.93L207.34 35.46H207L205.42 40.28Z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 18.84L18.71 0.119995L34.31 15.72L28.07 21.96L24.95 18.84L21.83 21.96L24.95 25.08L21.83 28.2L24.95 31.32L28.07 28.2L34.31 34.43L18.71 50.03L0 31.32L6.24 25.08L0 18.84Z"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.54 30.7V22.07H45.73V23H41.52V25.86H44.77L44.58 26.77H41.52V29.82H45.13C45.13 29.66 45.24 29.32 45.3 29.03C45.73 29.11 45.94 29.19 46.2 29.24C46.07 29.89 45.98 30.19 45.87 30.73L40.54 30.7Z"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M48.04 30.7L48.85 22.97H47.95V22.07H53.61V22.97H49.81L49.48 25.83H53.61V26.74H49.42L49.09 29.79H53.61V30.7H48.04Z"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M55.35 29.92L55.86 29.08C56.6533 29.5926 57.5756 29.8699 58.52 29.88C59.85 29.88 60.43 29.29 60.43 28.37C60.3893 28.0185 60.2373 27.6892 59.9963 27.4302C59.7552 27.1711 59.4377 26.9959 59.09 26.93L57.21 26.37C56.7183 26.2616 56.2813 25.9817 55.9771 25.5804C55.673 25.1791 55.5216 24.6827 55.55 24.18C55.55 22.81 56.63 21.94 58.27 21.94C59.1595 21.9319 60.0366 22.1486 60.82 22.57L60.46 23.35C59.7751 23.0247 59.0282 22.8508 58.27 22.84C57.21 22.84 56.53 23.3 56.53 24.13C56.545 24.4382 56.6592 24.7332 56.8557 24.9711C57.0521 25.209 57.3202 25.377 57.62 25.45L59.32 25.96C60.68 26.37 61.42 27.17 61.42 28.35C61.42 29.9 60.28 30.83 58.51 30.83C57.3851 30.8839 56.274 30.5639 55.35 29.92"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M68.48 22.07L69 23.66L68.21 23.9L67.9 23H65.8V30.7H64.8V23H62.7L62.41 23.92L61.58 23.65C61.8 22.99 61.9 22.65 62.08 22.09L68.48 22.07Z"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M71.07 22.07H70.09V30.7H71.07V22.07Z"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M81.1 27.65C80.8905 27.703 80.676 27.7331 80.46 27.74H78.86V30.74H77.86V22.07H80.56C80.9272 22.0739 81.2901 22.1503 81.6278 22.2948C81.9654 22.4392 82.2712 22.649 82.5277 22.9119C82.7841 23.1748 82.9861 23.4858 83.122 23.8269C83.258 24.1681 83.3253 24.5328 83.32 24.9C83.3041 25.3873 83.1667 25.8629 82.9205 26.2838C82.6743 26.7046 82.327 27.0573 81.91 27.31L83.03 29.79H83.69V30.7H83.26C83.0264 30.7291 82.79 30.6749 82.5924 30.5468C82.3949 30.4188 82.2488 30.2251 82.18 30L81.1 27.65ZM78.86 23V26.85H80.37C80.6345 26.8691 80.9 26.8335 81.1501 26.7454C81.4002 26.6573 81.6294 26.5186 81.8235 26.338C82.0177 26.1573 82.1725 25.9387 82.2783 25.6956C82.3842 25.4525 82.4388 25.1902 82.4388 24.925C82.4388 24.6599 82.3842 24.3976 82.2783 24.1545C82.1725 23.9114 82.0177 23.6927 81.8235 23.5121C81.6294 23.3314 81.4002 23.1928 81.1501 23.1047C80.9 23.0166 80.6345 22.9809 80.37 23H78.86Z"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M89.52 22.07L92.33 30.7H91.33L90.78 28.92H86.7L86.14 30.7H85.14L87.94 22.07H89.52ZM87 28H90.5L88.9 23H88.57L87 28Z"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M93.8 22.07H94.78V25.83H99.13V22.07H100.1V30.7H99.13V26.74H94.78V30.7H93.8V22.07Z"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M102.37 22.07L104.53 28.77C104.619 29.0572 104.683 29.3516 104.72 29.65V29.65C104.762 29.3475 104.833 29.0495 104.93 28.76C105.45 26.99 106.55 23.84 107.09 22.07H108.09C107.09 25.19 106.3 27.63 105.31 30.7H104.1L101.3 22.07H102.37Z"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M112.6 22.07L115.41 30.7H114.41L113.85 28.92H109.77L109.21 30.7H108.21L111.01 22.07H112.6ZM110.07 28H113.58L112 23H111.66L110.07 28Z"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M45.41 41.66H44.44L41.53 36.15H41.52V43.15H40.54V34.52H41.74L44.92 40.48H44.93L48.11 34.52H49.31V43.15H48.34V36.15H48.32L45.41 41.66Z"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M57.35 39.72V34.52H58.35V39.72C58.3812 40.1844 58.3144 40.6502 58.1539 41.0871C57.9934 41.5241 57.7428 41.9224 57.4184 42.2562C57.0941 42.59 56.7031 42.8519 56.271 43.0248C55.8388 43.1977 55.3751 43.2779 54.91 43.26C54.444 43.2828 53.9786 43.206 53.5447 43.0347C53.1107 42.8633 52.7184 42.6014 52.3937 42.2664C52.0691 41.9313 51.8197 41.5309 51.6621 41.0918C51.5045 40.6527 51.4425 40.185 51.48 39.72V34.52H52.48V39.72C52.4418 40.0652 52.4768 40.4146 52.5827 40.7453C52.6887 41.076 52.8632 41.3807 53.0949 41.6395C53.3265 41.8982 53.6102 42.1052 53.9272 42.2469C54.2443 42.3886 54.5877 42.4618 54.935 42.4618C55.2823 42.4618 55.6257 42.3886 55.9428 42.2469C56.2598 42.1052 56.5435 41.8982 56.7751 41.6395C57.0068 41.3807 57.1813 41.076 57.2873 40.7453C57.3932 40.4146 57.4282 40.0652 57.39 39.72"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M66.61 39.72V34.52H67.61V39.72C67.6412 40.1844 67.5744 40.6502 67.4139 41.0871C67.2534 41.5241 67.0028 41.9224 66.6784 42.2562C66.3541 42.59 65.9631 42.8519 65.531 43.0248C65.0988 43.1977 64.6351 43.2779 64.17 43.26C63.704 43.2828 63.2386 43.206 62.8047 43.0347C62.3708 42.8633 61.9784 42.6014 61.6537 42.2664C61.3291 41.9313 61.0797 41.5309 60.9221 41.0918C60.7646 40.6527 60.7025 40.185 60.74 39.72V34.52H61.74V39.72C61.7018 40.0652 61.7368 40.4146 61.8427 40.7453C61.9487 41.076 62.1232 41.3807 62.3549 41.6395C62.5865 41.8982 62.8702 42.1052 63.1872 42.2469C63.5043 42.3886 63.8477 42.4618 64.195 42.4618C64.5423 42.4618 64.8857 42.3886 65.2028 42.2469C65.5198 42.1052 65.8035 41.8982 66.0351 41.6395C66.2668 41.3807 66.4413 41.076 66.5473 40.7453C66.6532 40.4146 66.6882 40.0652 66.65 39.72"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M69.62 42.37L70.12 41.54C70.9178 42.0509 71.8427 42.328 72.79 42.34C74.12 42.34 74.7 41.75 74.7 40.82C74.6557 40.4682 74.5013 40.1395 74.2588 39.8808C74.0163 39.6222 73.6982 39.4469 73.35 39.38L71.48 38.82C70.9874 38.7118 70.5492 38.4322 70.2434 38.0312C69.9376 37.6302 69.784 37.1337 69.81 36.63C69.81 35.26 70.9 34.4 72.54 34.4C73.4256 34.3874 74.2998 34.6008 75.08 35.02L74.72 35.8C74.0383 35.4769 73.2944 35.3062 72.54 35.3C71.48 35.3 70.8 35.75 70.8 36.58C70.8134 36.8886 70.927 37.1845 71.1237 37.4227C71.3204 37.6609 71.5894 37.8285 71.89 37.9L73.59 38.42C74.1647 38.5089 74.6899 38.797 75.0737 39.2339C75.4576 39.6707 75.6757 40.2286 75.69 40.81C75.69 42.35 74.55 43.29 72.78 43.29C71.654 43.3402 70.543 43.0168 69.62 42.37"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M77.82 43.15V34.52H83V35.42H78.79V38.28H82.05L81.85 39.19H78.79V42.24H82.41C82.41 42.08 82.52 41.75 82.58 41.45C83.01 41.53 83.22 41.61 83.48 41.66C83.34 42.31 83.26 42.66 83.14 43.15H77.82Z"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M91.39 39.72V34.52H92.39V39.72C92.4152 40.1867 92.345 40.6536 92.1838 41.0923C92.0225 41.5309 91.7736 41.9321 91.4521 42.2714C91.1307 42.6107 90.7435 42.8809 90.3142 43.0655C89.8848 43.2502 89.4224 43.3454 88.955 43.3454C88.4876 43.3454 88.0252 43.2502 87.5959 43.0655C87.1665 42.8809 86.7793 42.6107 86.4579 42.2714C86.1364 41.9321 85.8875 41.5309 85.7262 41.0923C85.565 40.6536 85.4948 40.1867 85.52 39.72V34.52H86.52V39.72C86.4892 40.0603 86.5297 40.4034 86.6388 40.7272C86.748 41.051 86.9234 41.3486 87.1539 41.6009C87.3844 41.8532 87.6649 42.0547 87.9776 42.1925C88.2903 42.3304 88.6283 42.4016 88.97 42.4016C89.3117 42.4016 89.6497 42.3304 89.9624 42.1925C90.2751 42.0547 90.5556 41.8532 90.7861 41.6009C91.0166 41.3486 91.192 41.051 91.3012 40.7272C91.4103 40.4034 91.4508 40.0603 91.42 39.72"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M99.83 41.66H98.85L95.94 36.15H95.93V43.15H94.96V34.52H96.15L99.33 40.48H99.35L102.53 34.52H103.72V43.15H102.75V36.15H102.74L99.83 41.66Z"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M124.84 50.03V0H125.84V50.03H124.84Z"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 211,
    height: 51,
    viewBox: "0 0 211 51",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.eb2b6595.svg";
export { ForwardRef as ReactComponent };